export enum ExpandRecordModel {
  Modal = 'modal',
  Drawer = 'drawer',
}
